import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

// On vérifie si le serveur (ou react-snap) a déjà injecté du HTML
if (rootElement.hasChildNodes()) {
  // Si oui, on "hydrate" (on reprend le contrôle sur le HTML existant)
  ReactDOM.hydrateRoot(
    rootElement,
    <HelmetProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </HelmetProvider>
  );
} else {
  // Si non (en développement local par exemple), on crée le root normalement
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <HelmetProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </HelmetProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
